import { GetProgramItemsByContentIdentifiers } from 'types/services/magnolia/GetProgramItemsByContentIdentifiers';
import { GetProgramDayForDayNumberType } from 'types/services/spring/GetProgramDayForDayNumber';
import { GetProgramDayForTodayType } from 'types/services/spring/GetProgramDayForToday';

// append dynamic products from recipe and workouts "manually" -> PULSWM-3729
export async function appendDynamicSpringProducts(day: GetProgramDayForTodayType | GetProgramDayForDayNumberType) {
	const programItemsContents: GetProgramItemsByContentIdentifiers = [];

	day.programItems.forEach(({ type, selectedContentType, externalId }) => {
		if (
			!programItemsContents ||
			!externalId ||
			type !== 'DynamicProductProgramItem' ||
			!selectedContentType ||
			!selectedContentType.productId
		) {
			return;
		}
		programItemsContents.push({
			disableRetailerContext: !!selectedContentType.disableRetailerContext,
			externalId,
			itemType: 'PRODUCT_DYNAMIC',
			productId: selectedContentType.productId,
		});
	});

	return programItemsContents;
}
